"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.surveyUpdate = exports.surveyUnlockBulk = exports.surveyUnlock = exports.surveySuccess = exports.surveySubmitBulk = exports.surveySubmit = exports.surveySoftDeleteList = exports.surveySoftDeleteBulk = exports.surveySoftDelete = exports.surveySavePasscode = exports.surveyReviewApprovalReset = exports.surveyResumeBulk = exports.surveyResume = exports.surveyRestoreBulk = exports.surveyRestore = exports.surveyResetAvoid = exports.surveyReset = exports.surveyPrefight = exports.surveyPauseBulk = exports.surveyPause = exports.surveyMagicUrl = exports.surveyLockBulk = exports.surveyLock = exports.surveyListReviewAndApproval = exports.surveyListConfiguration = exports.surveyList = exports.surveyLinkedFund = exports.surveyImport = exports.surveyGetSurveyPasscode = exports.surveyFetchPasscode = exports.surveyFetchConfiguration = exports.surveyFetch = exports.surveyErrorSheetDownload = exports.surveyError = exports.surveyDownloadSurveyResponse = exports.surveyDownloadAll = exports.surveyDeleteBulk = exports.surveyDelete = exports.surveyCreate = exports.surveyCopyUrl = exports.surveyApproveBulk = exports.surveyApprove = exports.surveyAnalyticsUpdate = exports.surveyAnalyticsSave = exports.surveyAnalyticsGet = void 0;
var _survey = require("./survey.constant");
// @flow

// common success
var surveySuccess = function surveySuccess(actionType, data) {
  return {
    type: _survey.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.surveySuccess = surveySuccess;
var surveyError = function surveyError(actionType, error) {
  return {
    type: _survey.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * survey reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.surveyError = surveyError;
var surveyReset = function surveyReset(data) {
  return {
    type: _survey.actionTypes.RESET,
    payload: data
  };
};

/**
 * survey reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.surveyReset = surveyReset;
var surveyResetAvoid = function surveyResetAvoid(data) {
  return {
    type: _survey.actionTypes.RESET_AVOID,
    payload: data
  };
};

/**
 * List
 * @param payload
 * @returns api response
 * @description this function used to List.
 */
exports.surveyResetAvoid = surveyResetAvoid;
var surveyList = function surveyList(data) {
  return {
    type: _survey.actionTypes.LIST,
    payload: data
  };
};

/**
 * Fetch
 * @param payload
 * @returns api response
 * @description this function used to Fetch.
 */
exports.surveyList = surveyList;
var surveyFetch = function surveyFetch(data) {
  return {
    type: _survey.actionTypes.FETCH,
    payload: data
  };
};

/**
 * Fetch Passcode
 * @param payload
 * @returns api response
 * @description this function used to Fetch Passcode.
 */
exports.surveyFetch = surveyFetch;
var surveyFetchPasscode = function surveyFetchPasscode(data) {
  return {
    type: _survey.actionTypes.FETCH_PASSCODE,
    payload: data
  };
};

/**
 * Create
 * @param payload
 * @returns api response
 * @description this function used to Create.
 */
exports.surveyFetchPasscode = surveyFetchPasscode;
var surveyCreate = function surveyCreate(data) {
  return {
    type: _survey.actionTypes.CREATE,
    payload: data
  };
};

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to Update.
 * @param data
 */
exports.surveyCreate = surveyCreate;
var surveyUpdate = function surveyUpdate(data) {
  return {
    type: _survey.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Linked Fund.
 */
exports.surveyUpdate = surveyUpdate;
var surveyLinkedFund = function surveyLinkedFund(data) {
  return {
    type: _survey.actionTypes.LINKED_FUND,
    payload: data
  };
};

/**
 * Save Linked Fund
 * @param payload
 * @returns api response
 * @description this function used to Save Linked Fund.
 */
exports.surveyLinkedFund = surveyLinkedFund;
var surveySavePasscode = function surveySavePasscode(data) {
  return {
    type: _survey.actionTypes.SAVE_LINKED_FUND,
    payload: data
  };
};

/**
 * Lock
 * @param payload
 * @returns api response
 * @description this function used to Lock.
 */
exports.surveySavePasscode = surveySavePasscode;
var surveyLock = function surveyLock(data) {
  return {
    type: _survey.actionTypes.LOCK,
    payload: data
  };
};

/**
 * Lock Bulk
 * @param payload
 * @returns api response
 * @description this function used to Lock Bulk.
 */
exports.surveyLock = surveyLock;
var surveyLockBulk = function surveyLockBulk(data) {
  return {
    type: _survey.actionTypes.LOCK_BULK,
    payload: data
  };
};

/**
 * Unlock
 * @param payload
 * @returns api response
 * @description this function used to Unlock.
 */
exports.surveyLockBulk = surveyLockBulk;
var surveyUnlock = function surveyUnlock(data) {
  return {
    type: _survey.actionTypes.UNLOCK,
    payload: data
  };
};

/**
 * Unlock Bulk
 * @param payload
 * @returns api response
 * @description this function used to Unlock Bulk.
 */
exports.surveyUnlock = surveyUnlock;
var surveyUnlockBulk = function surveyUnlockBulk(data) {
  return {
    type: _survey.actionTypes.UNLOCK_BULK,
    payload: data
  };
};

/**
 * Soft Delete
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete.
 */
exports.surveyUnlockBulk = surveyUnlockBulk;
var surveySoftDelete = function surveySoftDelete(data) {
  return {
    type: _survey.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * Soft Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete Bulk.
 */
exports.surveySoftDelete = surveySoftDelete;
var surveySoftDeleteBulk = function surveySoftDeleteBulk(data) {
  return {
    type: _survey.actionTypes.SOFT_DELETE_BULK,
    payload: data
  };
};

/**
 * Submit
 * @param payload
 * @returns api response
 * @description this function used to Submit.
 */
exports.surveySoftDeleteBulk = surveySoftDeleteBulk;
var surveySubmit = function surveySubmit(data) {
  return {
    type: _survey.actionTypes.SUBMIT,
    payload: data
  };
};

/**
 * Submit Bulk
 * @param payload
 * @returns api response
 * @description this function used to Submit Bulk.
 */
exports.surveySubmit = surveySubmit;
var surveySubmitBulk = function surveySubmitBulk(data) {
  return {
    type: _survey.actionTypes.SUBMIT_BULK,
    payload: data
  };
};

/**
 * Pause
 * @param payload
 * @returns api response
 * @description this function used to Pause.
 */
exports.surveySubmitBulk = surveySubmitBulk;
var surveyPause = function surveyPause(data) {
  return {
    type: _survey.actionTypes.PAUSE,
    payload: data
  };
};

/**
 * Pause Bulk
 * @param payload
 * @returns api response
 * @description this function used to Pause Bulk.
 */
exports.surveyPause = surveyPause;
var surveyPauseBulk = function surveyPauseBulk(data) {
  return {
    type: _survey.actionTypes.PAUSE_BULK,
    payload: data
  };
};

/**
 * Resume
 * @param payload
 * @returns api response
 * @description this function used to Resume.
 */
exports.surveyPauseBulk = surveyPauseBulk;
var surveyResume = function surveyResume(data) {
  return {
    type: _survey.actionTypes.RESUME,
    payload: data
  };
};

/**
 * Resume Bulk
 * @param payload
 * @returns api response
 * @description this function used to Resume Bulk.
 */
exports.surveyResume = surveyResume;
var surveyResumeBulk = function surveyResumeBulk(data) {
  return {
    type: _survey.actionTypes.RESUME_BULK,
    payload: data
  };
};

/**
 * Download All
 * @param payload
 * @returns api response
 * @description this function used to Download All.
 */
exports.surveyResumeBulk = surveyResumeBulk;
var surveyDownloadAll = function surveyDownloadAll(data) {
  return {
    type: _survey.actionTypes.DOWNLOAD_ALL,
    payload: data
  };
};

/**
 * Download Survey Response
 * @param payload
 * @returns api response
 * @description this function used to Download Survey Response.
 */
exports.surveyDownloadAll = surveyDownloadAll;
var surveyDownloadSurveyResponse = function surveyDownloadSurveyResponse(data) {
  return {
    type: _survey.actionTypes.DOWNLOAD_SURVEY_RESPONSE,
    payload: data
  };
};

/**
 * Get Survey Passcode
 * @param payload
 * @returns api response
 * @description this function used to Get Survey Passcode.
 */
exports.surveyDownloadSurveyResponse = surveyDownloadSurveyResponse;
var surveyGetSurveyPasscode = function surveyGetSurveyPasscode(data) {
  return {
    type: _survey.actionTypes.GET_SURVEY_PASSCODE,
    payload: data
  };
};

/**
 * Copy Url
 * @param payload
 * @returns api response
 * @description this function used to Copy Url.
 */
exports.surveyGetSurveyPasscode = surveyGetSurveyPasscode;
var surveyCopyUrl = function surveyCopyUrl(data) {
  return {
    type: _survey.actionTypes.COPY_URL,
    payload: data
  };
};

/**
 * Magic Url
 * @param payload
 * @returns api response
 * @description this function used to Magic Url.
 */
exports.surveyCopyUrl = surveyCopyUrl;
var surveyMagicUrl = function surveyMagicUrl(data) {
  return {
    type: _survey.actionTypes.MAGIC_URL,
    payload: data
  };
};

// DELETED DATA

/**
 * Soft Delete List
 * @param payload
 * @returns api response
 * @description this function used to Soft Delete List.
 */
exports.surveyMagicUrl = surveyMagicUrl;
var surveySoftDeleteList = function surveySoftDeleteList(data) {
  return {
    type: _survey.actionTypes.SOFT_DELETE_LIST,
    payload: data
  };
};

/**
 * Restore
 * @param payload
 * @returns api response
 * @description this function used to Restore.
 */
exports.surveySoftDeleteList = surveySoftDeleteList;
var surveyRestore = function surveyRestore(data) {
  return {
    type: _survey.actionTypes.RESTORE,
    payload: data
  };
};

/**
 * Restore Bulk
 * @param payload
 * @returns api response
 * @description this function used to Restore Bulk.
 */
exports.surveyRestore = surveyRestore;
var surveyRestoreBulk = function surveyRestoreBulk(data) {
  return {
    type: _survey.actionTypes.RESTORE_BULK,
    payload: data
  };
};

/**
 * Delete
 * @param payload
 * @returns api response
 * @description this function used to Delete.
 */
exports.surveyRestoreBulk = surveyRestoreBulk;
var surveyDelete = function surveyDelete(data) {
  return {
    type: _survey.actionTypes.DELETE,
    payload: data
  };
};

/**
 * Delete Bulk
 * @param payload
 * @returns api response
 * @description this function used to Delete Bulk.
 */
exports.surveyDelete = surveyDelete;
var surveyDeleteBulk = function surveyDeleteBulk(data) {
  return {
    type: _survey.actionTypes.DELETE_BULK,
    payload: data
  };
};

// Uploader

/**
 * Prefight
 * @param payload
 * @returns api response
 * @description this function used to Prefight.
 */
exports.surveyDeleteBulk = surveyDeleteBulk;
var surveyPrefight = function surveyPrefight(data) {
  return {
    type: _survey.actionTypes.PREFIGHT,
    payload: data
  };
};

/**
 * Import
 * @param payload
 * @returns api response
 * @description this function used to Import.
 */
exports.surveyPrefight = surveyPrefight;
var surveyImport = function surveyImport(data) {
  return {
    type: _survey.actionTypes.IMPORT,
    payload: data
  };
};

/**
 * Error Sheet Download
 * @param payload
 * @returns api response
 * @description this function used to Error Sheet Download.
 */
exports.surveyImport = surveyImport;
var surveyErrorSheetDownload = function surveyErrorSheetDownload(data) {
  return {
    type: _survey.actionTypes.ERROR_SHEET_DOWNLOAD,
    payload: data
  };
};

// Analytics

/**
 * Analytics Save
 * @param payload
 * @returns api response
 * @description this function used to Analytics Save.
 */
exports.surveyErrorSheetDownload = surveyErrorSheetDownload;
var surveyAnalyticsSave = function surveyAnalyticsSave(data) {
  return {
    type: _survey.actionTypes.ANALYTICS_SAVE,
    payload: data
  };
};

/**
 * Analytics Get
 * @param payload
 * @returns api response
 * @description this function used to Analytics Get.
 */
exports.surveyAnalyticsSave = surveyAnalyticsSave;
var surveyAnalyticsGet = function surveyAnalyticsGet(data) {
  return {
    type: _survey.actionTypes.ANALYTICS_GET,
    payload: data
  };
};

/**
 * Analytics Update
 * @param payload
 * @returns api response
 * @description this function used to Analytics Update.
 */
exports.surveyAnalyticsGet = surveyAnalyticsGet;
var surveyAnalyticsUpdate = function surveyAnalyticsUpdate(data) {
  return {
    type: _survey.actionTypes.ANALYTICS_UPDATE,
    payload: data
  };
};

// Configuration

/**
 * List Configuration
 * @param payload
 * @returns api response
 * @description this function used to List Configuration.
 */
exports.surveyAnalyticsUpdate = surveyAnalyticsUpdate;
var surveyListConfiguration = function surveyListConfiguration(data) {
  return {
    type: _survey.actionTypes.LIST_CONFIGURATION,
    payload: data
  };
};

/**
 * Fetch Configuration
 * @param payload
 * @returns api response
 * @description this function used to Fetch Configuration.
 */
exports.surveyListConfiguration = surveyListConfiguration;
var surveyFetchConfiguration = function surveyFetchConfiguration(data) {
  return {
    type: _survey.actionTypes.FETCH_CONFIGURATION,
    payload: data
  };
};

// Review and Approve

/**
 * List Review Approval
 * @param payload
 * @returns api response
 * @description this function used to List Review Approval.
 */
exports.surveyFetchConfiguration = surveyFetchConfiguration;
var surveyListReviewAndApproval = function surveyListReviewAndApproval(data) {
  return {
    type: _survey.actionTypes.LIST_REVIEW_APPROVAL,
    payload: data
  };
};

/**
 * Approve
 * @param payload
 * @returns api response
 * @description this function used to Approve.
 */
exports.surveyListReviewAndApproval = surveyListReviewAndApproval;
var surveyApprove = function surveyApprove(data) {
  return {
    type: _survey.actionTypes.APPROVE,
    payload: data
  };
};

/**
 * Approve Bulk
 * @param payload
 * @returns api response
 * @description this function used to Approve Bulk.
 */
exports.surveyApprove = surveyApprove;
var surveyApproveBulk = function surveyApproveBulk(data) {
  return {
    type: _survey.actionTypes.APPROVE_BULK,
    payload: data
  };
};

/**
 * Review Approval Reset
 * @param payload
 * @returns api response
 * @description this function used to Review Approval Reset.
 */
exports.surveyApproveBulk = surveyApproveBulk;
var surveyReviewApprovalReset = function surveyReviewApprovalReset(data) {
  return {
    type: _survey.actionTypes.REVIEW_APPROVAL_RESET,
    payload: data
  };
};
exports.surveyReviewApprovalReset = surveyReviewApprovalReset;